import React from 'react';

import { faFileArrowUp, faFolderMinus, faFolderPlus, faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { Table } from '@buildoutinc/blueprint-react/ui/Table';

import { Checkbox } from 'components/ui/checkbox';
import Dropdown from 'components/dropdown';
import { formatDate } from 'helpers/formatters/date_time_formats';

import OrientationBadge from './orientation_badge';
import UsedInPopover from './used_in_popover';
import type { PageRecord } from './types';

interface Props {
  page: PageRecord;
  selected: boolean;
  onSelectedChange: (page: PageRecord, selected: boolean) => void;
}

// Shell menu: each action ships with its own ticket (BSD-37518, BSD-37521, BSD-37629).
const COMING_SOON = 'Coming soon';

export default function PageRow({ page, selected, onSelectedChange }: Props) {
  const noop = () => {};

  return (
    <Table.Row>
      <Table.Cell style={{ width: '32px' }}>
        <Checkbox
          aria-label={`Select ${page.name}`}
          checked={selected}
          onCheckedChange={(checked: boolean | 'indeterminate') => onSelectedChange(page, checked === true)}
        />
      </Table.Cell>
      <Table.Cell>
        {page.name}
        {page.userLabel && <Badge className="ms-2" variant="outline">{page.userLabel}</Badge>}
      </Table.Cell>
      <Table.Cell>
        <OrientationBadge orientation={page.orientation} />
      </Table.Cell>
      <Table.Cell>
        {page.documentsCount === 0 ? (
          <span className="text-muted">Not used</span>
        ) : (
          <UsedInPopover documents={page.documents} documentsCount={page.documentsCount} />
        )}
      </Table.Cell>
      <Table.Cell>{page.createdByName || 'Buildout Defaults'}</Table.Cell>
      <Table.Cell>{page.updatedAt ? formatDate(page.updatedAt) : '---'}</Table.Cell>
      <Dropdown.Cell style={{ height: 'auto' }}>
        <Dropdown.Item
          disabled
          disabledMessage={COMING_SOON}
          icon={faPenToSquare}
          label="Edit page"
          onClick={noop}
        />
        <Dropdown.Item
          disabled
          disabledMessage={COMING_SOON}
          icon={faFileArrowUp}
          label="Replace file"
          onClick={noop}
        />
        <Dropdown.Item
          disabled
          disabledMessage={COMING_SOON}
          icon={faFolderPlus}
          label="Add to documents"
          onClick={noop}
        />
        <Dropdown.Item
          disabled
          disabledMessage={page.documentsCount === 0 ? 'This page is not used in any documents' : COMING_SOON}
          icon={faFolderMinus}
          label="Remove from documents"
          onClick={noop}
        />
        <Dropdown.Item
          disabled
          disabledMessage={COMING_SOON}
          isDelete
          label="Delete page"
          onClick={noop}
        />
      </Dropdown.Cell>
    </Table.Row>
  );
}
